let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ahQoC")).then(() => parcelRequire('g1j2n'));